/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { registerLanguage } from '../_.contribution.js';
registerLanguage({
  id: 'javascript',
  extensions: ['.js', '.es6', '.jsx', '.mjs'],
  firstLine: '^#!.*\\bnode',
  filenames: ['jakefile'],
  aliases: ['JavaScript', 'javascript', 'js'],
  mimetypes: ['text/javascript'],
  loader: function () {
    return import('./javascript.js');
  }
});